import React from "react";
import { Link } from "react-router-dom";

const TransactionTable = () => {
  return (
    <section className="payments-page-section">
      <div className="payment-tabs-wrapper table-page">
        <ul className="nav nav-tabs payment-tabs">
          <li className="nav-item" role="presentation">
            <Link to="/payments" className="nav-link ">
              {" "}
              Payments
            </Link>
          </li>
          <li className="nav-item" role="presentation">
            <Link to="/payment-history" className="nav-link active">
              {" "}
              Payment History
            </Link>
          </li>
        </ul>
        <h5 className="form-title">Transaction Record</h5>
        <div className="table-responsive">
          <table className="table table-striped payment-history">
            <thead className="table-dark">
              <tr>
                <th>Date</th>
                <th>Booking Type</th>
                <th>Destination / Item</th>
                <th>Transaction ID</th>
                <th>Amount Paid</th>
                <th>Payment Method</th>
                <th>Status</th>
                <th>Invoice</th>
              </tr>
            </thead>
            <tbody>
              {[
                {
                  type: "Flight",
                  item: "Dubai to Paris",
                  status: "Paid",
                  img: <img src="/images/icons/paid.svg" alt="paid" />,
                  pill: "paid",
                },
                {
                  type: "Hotel",
                  item: "Hotel Atlantis",
                  status: "Processing",
                  img: <img src="/images/icons/pending.svg" alt="pending" />,
                  pill: "processing",
                },
                {
                  type: "eSIM",
                  item: "Rome eSIM 5GB",
                  status: "Failed",
                  img: <img src="/images/icons/failed.svg" alt="failed" />,
                  pill: "failed",
                },
                {
                  type: "eSIM",
                  item: "Rome eSIM 5GB",
                  status: "Refunded",
                  img: <img src="/images/icons/refunded.svg" alt="refunded" />,
                  pill: "refunded",
                },
              ].map((row, i) => (
                <tr key={i}>
                  <td>June 20, 2025</td>
                  <td>{row.type}</td>
                  <td>{row.item}</td>
                  <td>123434 - Stripe</td>
                  <td>$260.00 USD</td>
                  <td>
                    <strong>Visa **** 4242</strong>
                  </td>
                  <td>
                    <button className={`status-pill ${row.pill}`}>
                      {row.img}
                      {row.status}
                    </button>
                  </td>
                  <td>
                    <img
                      src="/images/icons/ticket.svg"
                      alt="download"
                      className="invoice-icon"
                    />
                  </td>
                </tr>
              ))}
            </tbody>
          </table>
        </div>
      </div>
    </section>
  );
};

export default TransactionTable;
